import { List, Drawer, Divider } from 'antd';
import styled from 'styled-components';

export const IconWrapper = styled.div`
  padding: 0 0.5rem;
  display: flex;
  height: 25px;
  background-color: #35b31c;
  border: 1px solid #269310;
  align-items: center;
  cursor: pointer;
  color: #fff;

  &:hover {
    background-color: #2168ff;
  }
`;

export const StyledList = styled(List)`
  .ant-list-item {
    padding: 0.5rem 1.5rem;
    pointer-events: cursor;

    .ant-list-item-meta {
      h4.ant-list-item-meta-title {
        color: #0046ff;
      }
    }

    &:hover {
      background-color: #e9f3fd;
    }

    h4 {
      margin-bottom: 0 !important;
    }

    .ant-list-item-meta-description {
      line-height: 1.3 !important;
    }
  }
`;

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-header-title {
    flex-direction: row-reverse;
    align-items: baseline;
  }

  .ant-drawer-body {
    padding: 0;
  }

  .ant-drawer-close {
    position: absolute;
    top: 15px;
    right: 0;
  }
`;

export const StyledUsecaseHeader = styled.h3`
  padding: 0.5rem 1.5rem;
  margin: 0;

  sup {
    color: #999;
  }
`;

export const StyledTitle = styled.div`
  h3 {
    color: #666;
    margin: 0;
  }

  h5 {
    line-height: 1.3;
    color: rgb(0 0 0 / 45%);
  }
`;

export const StyledDivider = styled(Divider)`
  margin: 1rem 0 !important;
`;
